<template>
  <div v-if="isLoading" class="text-center my-5">
    <div class="spinner-border text-primary" role="status" style="width: 4rem; height: 4rem;">
      <span class="visually-hidden">Chargement...</span>
    </div>
    <p class="mt-2">Chargement des chambres...</p>
  </div>

  <div v-else class="container-fluid py-4">

    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-clinique">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-building fs-2 text-primary"></i>
        <h2 class="fw-bold mb-0">Chambres</h2>
      </div>
      <button class="btn btn-primary btn-lg shadow-sm btn-clinique" @click="creation()">
        <i class="bi bi-plus-circle me-1"></i> 
      </button>
    </div>

    <!-- Filtres -->
    <div class="card p-3 mb-4 shadow-sm rounded card-clinique">
      <div class="row g-3 align-items-end">
        <div class="col-md-3">
          <label class="form-label fw-semibold">Rechercher</label>
          <input type="text" v-model="searchQuery" placeholder="Numéro ou type..." class="form-control form-control-clinique">
        </div>
        <div class="col-md-2">
          <label class="form-label fw-semibold">Items par page</label>
          <select v-model="itemsperpage" class="form-select form-select-clinique">
            <option v-for="item in itemsPerPageT" :key="item" :value="item">{{ item }}</option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label fw-semibold">Trier par</label>
          <select v-model="orderBy" class="form-select form-select-clinique">
            <option v-for="(value, key) in orderByTabs" :key="key" :value="value">{{ key }}</option>
          </select>
        </div>
        <div class="col-md-2">
          <label class="form-label fw-semibold">Ordre</label>
          <select v-model="sortOrder" class="form-select form-select-clinique">
            <option v-for="(value, key) in sortOrders" :key="key" :value="value">{{ key }}</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Tableau -->
    <div class="card shadow-sm rounded card-clinique">
      <div class="table-responsive">
        <table class="table align-middle text-center mb-0 table-hover modern-table-clinique">
          <thead>
            <tr>
              <th>#</th>
              <th>Numéro</th>
              <th>Type</th>
              <th>NBRE. LITS</th>
              <th> Lits libres</th>
              <th> Lits occupés</th>
              <th>Tarif / jour</th>
              <th> État chambre</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(chambre, index) in filteredChambres" :key="chambre.id">
              <td>{{ index + 1 + (currentPage - 1) * itemsperpage }}</td>
              <td>{{ chambre.numero }}</td>
              <td>{{ chambre.type.nom }}</td>
              <td>{{ chambre.nombreLit }}</td>

              <!-- Lits libres -->
              <td>
                <span class="badge bg-success">
                  {{ chambre.lits.filter(l => l.etat === 'libre').length }}
                </span>
              </td>

              <!-- Lits occupés -->
              <td>
                <span class="badge bg-danger">
                  {{ chambre.lits.filter(l => l.etat === 'Occupé').length }}
                </span>
              </td>

              <td>{{ chambre.type.tarifParJour.toLocaleString() }} F</td>

              <!-- État chambre -->
              <td>
                <span
                  :class="[
                    'badge',
                    getEtatBadgeClass(chambre)
                  ]">
                  {{ getEtatChambre(chambre) }}
                </span>
              </td>

              <td>
                <div class="dropdown">
                  <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown">
                    Actions
                  </button>
                  <ul class="dropdown-menu">
                    <li><a class="dropdown-item" @click="modifier(chambre.id)">Modifier</a></li>
                    <li><a class="dropdown-item text-danger" @click="supprimer(chambre.id)">Supprimer</a></li>
                  </ul>
                </div>
              </td>
            </tr>
            <tr v-if="chambres.length === 0">
              <td colspan="9" class="text-center py-3">Aucune donnée disponible</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="d-flex justify-content-end p-3">
        <ul class="pagination pagination-modern mb-0">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <button class="page-link" @click="changePage(currentPage - 1)">Précédent</button>
          </li>
          <li v-for="page in totalPages" :key="page" class="page-item" :class="{ active: page === currentPage }">
            <button class="page-link" @click="changePage(page)">{{ page }}</button>
          </li>
          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <button class="page-link" @click="changePage(currentPage + 1)">Suivant</button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';

export default {
  data() {
    return {
      isLoading: true,
      searchQuery: '',
      itemsperpage: 10,
      orderBy: 'ch.numero',
      sortOrder: 'asc',
      chambres: [],
      totalItems: 0,
      currentPage: 1,
      itemsPerPageT: [2, 4, 6, 10],
      orderByTabs: { Numéro: 'ch.numero', Type: 'ch.type', Statut: 'ch.isEnabled' },
      sortOrders: { Croissant: 'asc', Décroissant: 'desc' },
      isFirstLoad: true
    };
  },
  computed: {
    filteredChambres() {
      if (!this.searchQuery) return this.chambres;
      return this.chambres.filter(c =>
        c.numero.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        c.type.nom.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        (c.etat && c.etat.toLowerCase().includes(this.searchQuery.toLowerCase()))
      );
    },
    totalPages() {
      return Math.ceil(this.totalItems / this.itemsperpage);
    }
  },
  methods: {
    creation() { this.$router.push({ name: 'create_chambre' }); },
    async getChambres() {
      if (this.isFirstLoad) { this.isLoading = true; this.isFirstLoad = false; }
      try {
        const response = await api.getItems('chambres', {
          orderBy: this.orderBy, sortOrder: this.sortOrder, itemsperpage: this.itemsperpage,
          page: this.currentPage, search: this.searchQuery
        });
        const { data, meta } = response.data;
        this.chambres = data;
        this.totalItems = meta?.total_records || data.length;
      } catch (error) {
        console.error('Erreur lors du chargement des chambres :', error);
      } finally { this.isLoading = false; }
    },

    getEtatChambre(chambre) {
      const totalLits = chambre.lits.length;
      const libres = chambre.lits.filter(l => l.etat === 'libre').length;

      if (libres === totalLits) return 'Disponible';
      if (libres === 0) return 'Occupé';
      return 'Partiellement occupé';
    },

    getEtatBadgeClass(chambre) {
      const etat = this.getEtatChambre(chambre);
      return {
        'bg-success': etat === 'Disponible',
        'bg-danger': etat === 'Occupé',
        'bg-warning text-dark': etat === 'Partiellement occupé'
      };
    },

    changePage(page) { if (page > 0 && page <= this.totalPages) this.currentPage = page; this.getChambres(); },
    modifier(id) { this.$router.push({ name: 'edit_chambre', params: { id } }); },
    async supprimer(id) {
      if (!window.confirm("Voulez-vous vraiment supprimer cette chambre ?")) return;
      try { this.isLoading = true; await api.deleteItem('chambres', id); this.getChambres(); }
      catch (error) { alert("Erreur lors de la suppression."); }
      finally { this.isLoading = false; }
    }
  },
  watch: {
    searchQuery() { this.currentPage = 1; this.getChambres(); },
    itemsperpage() { this.currentPage = 1; this.getChambres(); },
    orderBy() { this.getChambres(); },
    sortOrder() { this.getChambres(); }
  },
  created() { this.getChambres(); }
};
</script>
